type SurveyAnswers = {
  [key: string]: any
}

function getDrugLine(name: string, value: any): string {
  const internationalName = value.internationalName || ''
  const dosing = value.dosing || ''
  const brand = value.brand || ''
  const galenicForm = value.galenicForm || ''
  const route = value.route || ''
  const frequency = Array.isArray(value.frequency) ? value.frequency.join(' - ') : ''
  const duration = value.duration || ''
  const noExchangeable = value.isNonExchangeable ? 'non substituable' : ''

  const line = ['- ', name, internationalName, dosing, brand, galenicForm, route, frequency, duration, noExchangeable]
    .filter((part) => part !== '')
    .join(' ')
    .trim()
  return line
}

export function processPrescriptionInfo(
  surveyAnswers: SurveyAnswers,
  direction: 'to' | 'from',
  options?: any,
): SurveyAnswers {
  if (direction === 'from' && !options?.isCompleted === true) {
    return surveyAnswers
  }

  const result: SurveyAnswers = { ...surveyAnswers }

  let exemptDrugs: string[] = []
  let otherDrugs: string[] = []

  Object.entries(surveyAnswers).forEach(([key, value]) => {
    if (key.startsWith('drug_')) {
      const drugDetails = value[Object.keys(value)[0]]
      const drugName = Object.keys(value)[0]
      const drugLine = getDrugLine(drugName, drugDetails)

      const isExempt = drugDetails.isExempt === 'true'

      if (isExempt) {
        exemptDrugs.push(drugLine)
      } else {
        otherDrugs.push(drugLine)
      }
    } else if (key === 'other-drugs' && value?.length) {
      value.forEach((drugDetails: any) => {
        const drugLine = getDrugLine(drugDetails?.drugs, drugDetails)

        const isExempt = drugDetails.isExempt === 'true'

        if (isExempt) {
          exemptDrugs.push(drugLine)
        } else {
          otherDrugs.push(drugLine)
        }
      })
    }
  })

  if (exemptDrugs.length > 0) {
    result.drugs_exempt = exemptDrugs.join('\n\n')
  }
  if (otherDrugs.length > 0) {
    result.drugs_other = otherDrugs.join('\n\n')
  }

  return result
}
